export const SORTING_OPTIONS = {
  BEST_MATCHES: 'best_matches',
  PRICE_ASC: 'price_asc',
  PRICE_DESC: 'price_desc',
  AVAILABILITY_UPDATE: 'availability_update',
  RECENCY: 'recency',
  RATINGS: 'ratings'
};
